import React, { createRef } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class VoteStars extends React.Component {
    constructor(props) {
        super(props);

        this.resetTimer = null;

        this.state = {
            hoveredStar: null,
            hoveredHorizontalPosition: 1.0
        }
    }

    star1Ref = createRef();
    star2Ref = createRef();
    star3Ref = createRef();
    star4Ref = createRef();
    star5Ref = createRef();

    onResetTimer() {
        if (this.props.canEditVote === false) return;
        this.setState({ hoveredStar: null });
        this.resetTimer = null;
    }

    armResetTimer() {
        this.disarmResetTimer();
        this.resetTimer = setTimeout(() => this.onResetTimer(), 5000);
    }

    disarmResetTimer() {
        if (this.resetTimer !== null) {
            clearTimeout(this.resetTimer);
            this.resetTimer = null;
        }
    }

    handleMouseMove(n, e, componentRef) {
        if (this.props.canEditVote === false) return;
        const rect = componentRef.current.getBoundingClientRect();
        const dx = (e.clientX - rect.x) / rect.width;
        this.setState({ hoveredStar: n, hoveredHorizontalPosition: dx });
        this.armResetTimer();
    }
    
    handleMouseLeave(n) {
        if (this.props.canEditVote === false) return;
        if (this.state.hoveredStar === n) {
            this.setState({ hoveredStar: null });
            this.disarmResetTimer();
        }
    }

    handleClick(n, e, componentRef) {
        if (this.props.canEditVote === false) return;
        if (this.props.onVote) {
            const rect = componentRef.current.getBoundingClientRect();
            const dx = ((e.clientX - rect.x) / rect.width) || 0.0;
            const star = n || 0;
            var vote = 20.0 * star;
            if (dx < 0.25) vote -= 20.0;
            else if (dx < 0.75) vote -= 10.0;
            this.props.onVote(vote);
            this.disarmResetTimer();
            this.setState({ hoveredStar: n, hoveredHorizontalPosition: dx });
        }
    }

    renderStar(n, componentRef) {
        var target = 0.0;
        if (this.state.hoveredStar === null) {
            if (this.props.vote !== undefined && this.props.vote !== null) {
                target = Math.round(this.props.vote / 10) / 2;
            }
        }
        else {
            target = this.state.hoveredStar + this.state.hoveredHorizontalPosition - 0.75;
        }
        
        var starColor;
        const hasVote = this.props.vote !== undefined && this.props.vote !== null;
        if (!hasVote && this.state.hoveredStar === null) {
            starColor = this.props.noVoteColor || "indianred";
        }
        else if (n > (target + 0.5)) {
            starColor = this.props.inactiveColor || "ghostwhite";
        }
        else {
            starColor = this.props.activeColor || "gold";
        }
        const starSize = this.props.starSize || "2em";

        if (n <= target) {
            return (
                <FaStar size={starSize} color={starColor} className="far-star"
                        onMouseMove={(e) => this.handleMouseMove(n, e, componentRef)}
                        onMouseLeave={() => this.handleMouseLeave(n)}/>
            );
        }
        else if (n <= (target + 0.5)) {
            return (
                <FaStarHalfAlt size={starSize} color={starColor}
                onMouseMove={(e) => this.handleMouseMove(n, e, componentRef)}
                onMouseLeave={() => this.handleMouseLeave(n)}/>
            );
        }
        else {
            return (
                <FaStar size={starSize} color={starColor}
                onMouseMove={(e) => this.handleMouseMove(n, e, componentRef)}
                onMouseLeave={() => this.handleMouseLeave(n)}/>
            );
        }
    }
    
    render() {        
        return (
            <Container fluid>
                <Row xs="auto" style={{ paddingLeft: "0", paddingRight: "0" }}>
                    <Col ref={this.star1Ref} xs="auto" style={{ paddingLeft: "0", paddingRight: "0" }} onClick={(e) => this.handleClick(1, e, this.star1Ref)}>
                        {this.renderStar(1, this.star1Ref)}
                    </Col>
                    <Col ref={this.star2Ref} xs="auto" style={{ paddingLeft: "0", paddingRight: "0" }} onClick={(e) => this.handleClick(2, e, this.star2Ref)}>
                        {this.renderStar(2, this.star2Ref)}
                    </Col>
                    <Col ref={this.star3Ref} xs="auto" style={{ paddingLeft: "0", paddingRight: "0" }} onClick={(e) => this.handleClick(3, e, this.star3Ref)}>
                        {this.renderStar(3, this.star3Ref)}
                    </Col>
                    <Col ref={this.star4Ref} xs="auto" style={{ paddingLeft: "0", paddingRight: "0" }} onClick={(e) => this.handleClick(4, e, this.star4Ref)}>
                        {this.renderStar(4, this.star4Ref)}
                    </Col>
                    <Col ref={this.star5Ref} xs="auto" style={{ paddingLeft: "0", paddingRight: "0" }} onClick={(e) => this.handleClick(5, e, this.star5Ref)}>
                        {this.renderStar(5, this.star5Ref)}
                    </Col>
                </Row>
            </Container>
        );
    }
}